module.exports = __webpack_public_path__ + "img/Proctoringgray.9a9122b8.svg";